import cn from 'classnames';
import React, { memo, useRef, useState, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useBoolean, preventBodyScroll } from '@sravni/react-utils';
import pluralize from '@sravni/utils/lib/pluralize';
import { Cross } from '../icons/Cross.js';
import { Pixel } from '../Pixel/index.js';
import modules_3734c084 from './fullscreen-wrapper.module.scss.js';
import { normalizeFullscreenBanner } from './normalizeFullscreenBanner.js';

let portalContainer = null;
const portalAttribute = 'portal-banner-container';
const FullScreenWrapper = memo(({ bannerInfo, setBannerShown }) => {
    const [isContainerMounted, setIsContainerMounted] = useBoolean(false);
    const [isBannerVisible, setBannerVisible] = useBoolean(false);
    const firstRenderRef = useRef(true);
    const [countdownTime, setCountdownTime] = useState(10);
    const { pixels, data: { width, height, scripts, contentStyle, html }, } = normalizeFullscreenBanner(bannerInfo);
    const portal = React.useMemo(() => {
        if (portalContainer) {
            return portalContainer;
        }
        const el = document.querySelector(`div[${portalAttribute}]`);
        if (el) {
            portalContainer = el;
            return portalContainer;
        }
        portalContainer = document.createElement('div');
        portalContainer.setAttribute(portalAttribute, '');
        return portalContainer;
    }, []);
    const handleCloseModal = useCallback(() => {
        setBannerVisible.off();
    }, [setBannerVisible]);
    useEffect(() => {
        if (!firstRenderRef.current)
            return;
        setBannerShown();
        setBannerVisible.on();
        setCountdownTime(Number(bannerInfo?.data?.timer) ?? 10);
        firstRenderRef.current = false;
    }, [bannerInfo?.data?.timer, setBannerShown, setBannerVisible]);
    useEffect(() => {
        if (!isBannerVisible)
            return;
        const counterId = setInterval(() => {
            if (countdownTime > 0) {
                setCountdownTime(countdownTime - 1);
            }
            else if (countdownTime === 0) {
                handleCloseModal();
            }
        }, 1000);
        return () => {
            clearInterval(counterId);
        };
    }, [countdownTime, handleCloseModal, isBannerVisible]);
    useEffect(() => {
        if (!portal || isContainerMounted)
            return;
        document.body.appendChild(portal);
        setIsContainerMounted.on();
    }, [isContainerMounted, portal, setIsContainerMounted]);
    useEffect(() => {
        if (isBannerVisible) {
            preventBodyScroll(true);
        }
        else {
            preventBodyScroll(false);
        }
        return () => preventBodyScroll();
    }, [isBannerVisible]);
    const banner = (React.createElement("div", { className: cn(modules_3734c084.wrapper, { [modules_3734c084['wrapper--hidden']]: !isBannerVisible }) },
        React.createElement("div", { className: modules_3734c084.overlay, onClick: handleCloseModal }),
        React.createElement("div", { className: modules_3734c084.innerWrapper },
            React.createElement(Pixel, { pixels: isBannerVisible ? pixels?.onShow : pixels?.onClose }),
            React.createElement("div", { className: modules_3734c084.header },
                React.createElement("div", null,
                    "\u0411\u0430\u043D\u043D\u0435\u0440 \u0437\u0430\u043A\u0440\u043E\u0435\u0442\u0441\u044F \u0447\u0435\u0440\u0435\u0437 ",
                    countdownTime,
                    " ",
                    pluralize(countdownTime, 'секунду', 'секунды', 'секунд')),
                React.createElement("div", { className: modules_3734c084.closeButton, onClick: handleCloseModal },
                    React.createElement(Cross, null))),
            React.createElement("script", null, scripts),
            React.createElement("style", null, contentStyle),
            React.createElement("div", { style: { width: `${Number(width)}px`, height: `${Number(height)}px`, overflow: 'hidden' }, dangerouslySetInnerHTML: { __html: html } }))));
    if (portal && isContainerMounted) {
        return ReactDOM.createPortal(banner, portal);
    }
    return null;
});

export { FullScreenWrapper };
//# sourceMappingURL=index.js.map
